import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import { motion, animate, useInView } from "framer-motion";

import { iconos } from "../../../assets";

const Counter = ({ value }) => {
  const [displayValue, setDisplayValue] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (isInView) {
      const targetValue = parseInt(value);
      const controls = animate(0, targetValue, {
        duration: 2,
        ease: "easeOut",
        delay: 0.5,
        onUpdate: (latest) => setDisplayValue(Math.round(latest))
      });
      return () => controls.stop();
    }
  }, [isInView, value]);

  return <h3 ref={ref}>{displayValue}%</h3>;
};

const Impacto = ({ variants }) => {
  const metrics = [
    { value: "50%", label: "Reduction in human labor hours", icon: iconos.plazo },
    { value: "70%", label: "Improvement in response time", icon: iconos.beneficio },
    { value: "38%", label: "Reduction in operating costs", icon: iconos.valor },
    { value: "94%", label: "Document filtering accuracy", icon: iconos.llave },
  ];

  return (
    <div className="impacto section relative">
      <div className="container-lg flex flexCol alignCenter">
        <motion.h2
          variants={variants}
          initial="initial"
          whileInView="ani"
          viewport={{ once: true }}
          className="impactoTitle"
        >
          Our Results
        </motion.h2>
        <div className="metricsGrid">
          {metrics.map((metric, index) => (
            <motion.div
              key={index}
              className="metricCard"
              variants={variants}
              initial="initial"
              whileInView="ani"
              viewport={{ once: true }}
              custom={index * 0.2}
            >
              <div className="iconContainer">
                <div
                  className="iconColorMask"
                  style={{
                    WebkitMaskImage: `url(${metric.icon.src})`,
                    maskImage: `url(${metric.icon.src})`
                  }}
                />
              </div>
              <Counter value={metric.value} />
              <p>{metric.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Impacto;
